{
	"type": "symbol",
	"minzoom": 11,
	"layout": {
		"icon-image": [
			"case",
			[
				"all",
				[">=", ["index-of", "(", ["get", "advisory_sign"]], 0],
				[">", ["length", ["get", "advisory_sign_direction"]], 0]
			],
			[
				"concat",
				"safecurves:advisory_sign_",
				[
					"slice",
					["get", "advisory_sign"],
					["+", ["index-of", "(", ["get", "advisory_sign"]], 1],
					["index-of", ")", ["get", "advisory_sign"]]
				],
				[
					"case",
					["==", ["get", "advisory_sign_direction"], "Both"],
					"L",
					["slice", ["get", "advisory_sign_direction"], 0, 1]
				]
			],
			"safecurves:fallback"
		],
		"icon-size": ["match", ["get", "advisory_sign"], "Chevron Alignment (W1-8)", 0.18, 0.34],
		"icon-allow-overlap": true,
		"icon-offset": [0, -15]
	},
	"paint": {
		"icon-opacity": 1
	}
}
